// extracted by mini-css-extract-plugin
module.exports = {"title":"PackageInfo_title__2bgjo","content":"PackageInfo_content__1GOTH"};